import { render, staticRenderFns } from "./ElInputTag.vue?vue&type=template&id=15c2bd70&scoped=true&"
import script from "./ElInputTag.vue?vue&type=script&lang=js&"
export * from "./ElInputTag.vue?vue&type=script&lang=js&"
import style0 from "./ElInputTag.vue?vue&type=style&index=0&id=15c2bd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2bd70",
  null
  
)

export default component.exports